import { IconButton } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd";
import { useTranslation } from "@localization/useTranslation";
import { addSectionIcon, addSubsectionIcon } from "@common/icons";
import PolicyEditableItem from "./PolicyEditableItem";
import { PolicyControl, PolicySubsection } from "./PolicySections.types";

export interface PolicySubsectionItemProps {
    subsection: PolicySubsection;
    sectionIndex: number;
    subIndex: number;
    setFocusOnTitle: boolean;
    availableControls: Array<PolicyControl>;
    disabled: boolean;
    readOnlyPreview: boolean;
    dragHandleProps: DraggableProvidedDragHandleProps | null;
    onTitleChange: (title: string) => void;
    onContentChange: (content: string) => void;
    onLinkedControlsChange: (linkedControlIds: string[]) => void;
    onDelete: () => void;
    onAddAfter: () => void;
    onAddSectionAfter: () => void;
    isAdding: boolean;
    isAddingSectionAfter: boolean;
    id: string;
    isEditingContent: boolean;
    onStartEditingContent: () => void;
}

function PolicySubsectionItem(props: PolicySubsectionItemProps) {
    const { translateString } = useTranslation();
    const {
        subsection,
        sectionIndex,
        subIndex,
        setFocusOnTitle,
        availableControls,
        disabled,
        readOnlyPreview,
        dragHandleProps,
        onTitleChange,
        onContentChange,
        onLinkedControlsChange,
        onDelete,
        onAddAfter,
        onAddSectionAfter,
        isAdding,
        isAddingSectionAfter,
        id,
        isEditingContent,
        onStartEditingContent,
    } = props;

    return (
        <PolicyEditableItem
            numberLabel={`${sectionIndex + 1}.${subIndex + 1}`}
            title={subsection.title}
            content={subsection.content}
            linkedControlIds={subsection.linkedControlIds}
            availableControls={availableControls}
            controlsHeaderKey="controlsRequiredBySubsection"
            setFocusOnTitle={setFocusOnTitle}
            disabled={disabled}
            readOnlyPreview={readOnlyPreview}
            dragHandleProps={dragHandleProps}
            showInlineDragHandle
            titleFontSize={18}
            onTitleChange={onTitleChange}
            onContentChange={onContentChange}
            onLinkedControlsChange={onLinkedControlsChange}
            onDelete={onDelete}
            id={id}
            isEditingContent={isEditingContent}
            onStartEditingContent={onStartEditingContent}
            extraActions={
                !disabled && (
                    <>
                        <DotLegalTooltip text={translateString("addSection")}>
                            <span>
                                <IconButton size="small" onClick={onAddSectionAfter} disabled={isAddingSectionAfter} aria-label="add section after subsection">
                                    {addSectionIcon}
                                </IconButton>
                            </span>
                        </DotLegalTooltip>
                        <DotLegalTooltip text={translateString("addSubsection")}>
                            <span>
                                <IconButton size="small" onClick={onAddAfter} disabled={isAdding} aria-label="add subsection">
                                    {addSubsectionIcon}
                                </IconButton>
                            </span>
                        </DotLegalTooltip>
                    </>
                )
            }
        />
    );
}

export default PolicySubsectionItem;
